import { useAuth0 } from "@auth0/auth0-react";
import IconButton from "@mui/material/IconButton";
import {
  Document,
  Image,
  Link,
  Note,
  PDFDownloadLink,
  Page,
  StyleSheet,
  Svg,
  Text,
  View,
  pdf,
  usePDF,
} from "@react-pdf/renderer";
import dateIcon from "assets/icons/date-picker.svg";
import { LabelField } from "components";
import { MenuMultiCheckBox } from "components/MenuMultiCheckBox/MenuMultiCheckBox";
import { MyCheckbox } from "components/MyCheckbox";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { debounce, filter } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { toastr } from "react-redux-toastr";
import MaskedInput from "react-text-mask";
import { DateRangePicker } from "rsuite";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import thousands from "thousands";
import FinanceService from "../../../Lib/API/Finance";
import { DateFormetContext } from "../../../app/App.js";
import Download from "../../../assets/icons/Download.svg";
import Share from "../../../assets/icons/Share.svg";
import Eye from "../../../assets/icons/eyeIcon.svg";
import SuccessIcon from "../../../assets/icons/successStatement.svg";
import MyButton from "../../../components/MyButton";
import SearchDownShift from "../../../components/downmshift/DownShift";
import { TextAreaMessage } from "../Theme";
import "./styles.scss";

const NewTaxStatement = ({
  onSearchChange,
  documentData,
  documentType,
  downloadPDF,
  sharePDF,
  closeModal,
  viewDocumentHandler,
  downloadFileHandler,
  documentHandler
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [search, setSearch] = useState("");
  const [id, setId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [showZero, setShowZero] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState("");
  const [docData, setDocData] = useState([]);
  const [isSuccess, setIsSucess] = useState(false);
  const [bol, setBol] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [calendar, setCalender] = useState(false);
  const [calendarEnd, setCalenderEnd] = useState(false);
  const [ledgers, setLedgers] = useState([]);
  const [isLedgerLoading, setIsLedgerLoading] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [showBalance, setShowBalance] = useState(false);
  const [allOpenCharges, setAllOpenCharges] = useState(false);
  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
  const [excludeActivePayment, setExcludeActivePayment] = useState(false);


  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");



  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      all_ledger_sub_data: [],
      selectAllLedger: false,
      selectAllSubLedger: false,
      addNote: false,
      note: "",
    },
    validationSchema: "",
    onSubmit: async (values) => { },
  });
  useEffect(() => {
    setIsLedgerLoading(true);
    async function getLedgeraccounts() {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerListAll(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = ["Select All", ...res?.ledgers];
        setLedgers(arrayWithSelectAll);
      }
      setIsLedgerLoading(false);
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  const fetchAccounts = async () => {
    // enableLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.getACcountNames(token, search, true)
      .then((res) => {
        if (res?.accounts) {
          const option2 =
            res.accounts &&
            res.accounts?.map((item, index) => ({
              id: item?._id,
              name: item?.family_name,
            }));

          setData(option2);
        }
        // enableLoading(false);
      })
      .catch((error) => {
        toastr.error(error?.data?.message);
      });
  };
  useEffect(() => {
    fetchAccounts();
  }, [search]);


  const getAllSelectedLedger = () => {
    const { all_ledger_sub_data } = formik?.values || {};

    if (!all_ledger_sub_data || !all_ledger_sub_data?.length) return { allLedgerIds: [], allSubLedgerIds: [] };

    const allLedgerIds = [];
    const allSubLedgerIds = [];

    all_ledger_sub_data.forEach(({ type, id }) => {
      if (type === "ledger") {
        allLedgerIds.push(id);
      } else if (type === "sub_ledger") {
        allSubLedgerIds.push(id);
      }
    });

    return {
      allLedgerIds,
      allSubLedgerIds,
    };
  }

  const fetchMyAPI = async (e) => {
    const token = await getAccessTokenSilently();
    const { allLedgerIds } = getAllSelectedLedger();
    const body = {
      account: {
        id: id,
        name: search,
      },
      start: !allOpenCharges ? moment(dateRange[0]).format("MM/DD/YYYY") : undefined,
      end: !allOpenCharges ? moment(dateRange[1]).format("MM/DD/YYYY") : undefined,
      showZero: !allOpenCharges ? showZero : undefined,
      ledger: formik?.values?.selectAllLedger ? allLedgerIds : formik?.values?.ledger || [],
      subLedger: (formik?.values?.selectAllLedger && formik?.values?.selectAllSubLedger) ? [] : formik?.values?.subLedger || [],
      showBalance: showBalance,
      allOpenCharges: allOpenCharges,
      excludeActivePayment: excludeActivePayment,
      note: formik.values?.addNote ? formik.values?.note : undefined,
    };

    await FinanceService.createNewTaxStatement(body, token)
      .then((res) => {
        const result = res;

        documentData(result.result);
        setDocData(result.result);
        setIsSucess(!isSuccess);
        setBol(true);
        setTimeout(() => {
          setBol(false);
        }, 3000);
      })
      .catch((error) => {
        toastr.error(error?.data?.message);
      });
  };
  const create = () => {
    const checkDate = allOpenCharges ? true : dateRange[0] !== null && dateRange[1] !== null;
    if (checkDate && search !== "" && id !== "" && (formik.values?.addNote ? formik.values?.note : true)) {
      fetchMyAPI();
    } else {
      toastr.error("Error", "Please Fill all the fields");
    }

    window.addEventListener("save-transaction", fetchMyAPI);
    return () => {
      window.removeEventListener("save-transaction", fetchMyAPI);
    };
  };

  const handelView = () => {
    documentType(docData.type);
    documentData(docData);
  };
  const handelDelete = () => {
    documentData(docData);
    downloadPDF(docData.type);
  };
  const HandleShare = () => {
    sharePDF("tax_statement");
  };

  const [logoImage, setLogoImage] = useState(null);

  useEffect(() => {
    setLogoImage(localStorage?.getItem("Base64"));
  }, []);

  const styles = StyleSheet.create({
    page: {
      height: "60vh",
    },
    logo: {
      width: "130pt",
      height: "50pt",
    },
    docMain: {
      padding: "30pt",
    },
    orgName: {
      fontWeight: "600",
      fontSize: "12pt",
    },
    docoHead: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    docOrgDetails: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docOrgDetailsAddress: {
      marginTop: "10px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docOrgDetailsPhone: {
      marginTop: "5px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docBody: {
      marginTop: "20px",
    },
    docoBodyHeading: {
      marginBottom: "10px",
    },
    docoBodyHeadingHead: {
      borderBottom: "2px solid #4f4f4f",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      marginBottom: "15px",
    },
    docoBodyHeadingHeadH1: {
      fontSize: "15pt",
      fontWeight: "800",
    },
    docoBodyHeadingHeadP: {
      fontSize: "10pt",
      fontWeight: "700",
    },
    docoBodySubHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docoBodySubHeadName: {
      fontSize: "10px",
    },
    docoBodySubHeadDate: {
      fontSize: "10px",
    },
    docoBodySubHeadAddresses: {
      display: "flex",
      flexDirection: "column",
      marginTop: "2pt",
    },
    docoBodySubHeadcity: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadZip: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadPhone: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    outStandingText: { fontSize: "12pt" },
    dateDetails: {
      paddingBottom: "5px",
      display: "flex",
      flexDirection: "column",
    },
    outStandingMain: {
      display: "flex",
      margin: "15px 0px",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
    },
    tableHeading: {
      padding: "10pt 5pt",
      backgroundColor: "#4f4f4f",
      color: "white",
      display: "flex",
    },
    tableHeadingText: {
      fontSize: "12pt",
    },
    HeaderRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    BodyRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      flexDirection: "row",
      borderTop: "2px solid white",
    },
    DateCol: {
      width: "150px",
    },
    ChargeDetailCol: {
      width: "180px",
    },
    AmountCol: {
      width: "150px",
    },
    AmountPaidCol: {
      width: "150px",
    },
    AmountDueCol: {
      width: "150px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12pt",
      padding: "10pt 5pt",
      fontWeight: "900",
      flexDirection: "row",
      marginTop: "40px",
      padding: "10pt 5pt",
      backgroundColor: "#f7f7f7",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "52pt",
      padding: "15pt 0pt",
      borderTop: "2px solid black",
      fontSize: "10pt",
    },
    footerBorder: {
      display: "flex",
      flexDirection: "row",
      padding: "5px 0pt",
      backgroundColor: "#4f4f4f",
    },
  });

  // let totalAmount = 0;
  // let totalAmount_due = 0;
  // let totalAmountPaid = 0;

  const [totalAmount, settotalAmount] = useState(0);
  const [totalAmount_due, settotalAmount_due] = useState(0);
  const [totalAmountPaid, settotalAmountPaid] = useState(0);

  useEffect(() => {
    let newState =
      docData?.transaction?.length > 0
        ? docData?.transaction?.map((e, i) =>
          docData?.transaction.reduce(
            (partialSum, a) => partialSum + a?.total_amount,
            0
          )
        )
        : 0;

    let newStateTotalPaid =
      docData?.transaction?.length > 0
        ? docData?.transaction?.map((e, i) =>
          docData?.transaction.reduce(
            (partialSum, a) =>
              partialSum + (a?.total_paid === null ? 0 : a?.total_paid ?? 0),
            0
          )
        )
        : 0;

    let newStateAmount_due = docData?.transaction?.map((e, i) =>
      docData?.transaction.reduce(
        (partialSum, a) =>
          partialSum + (a?.amount_due === null ? 0 : a?.amount_due ?? 0),
        0
      )
    );

    console.log(newStateTotalPaid, newStateAmount_due);
    console.log("totalAmount_due", totalAmount_due);
    settotalAmount(newState);
    settotalAmountPaid(newStateTotalPaid);
    settotalAmount_due(newStateAmount_due);

    // for (let i = 0; i < docData && docData?.transaction?.length; i++) {
    //   if (docData?.transaction) {
    //     if (docData?.transaction?.[i]?.total_paid) {
    //       if (docData?.transaction?.[i]?.total_paid === null)
    //         settotalAmountPaid((totalAmountPaid += 0));
    //       else {
    //         totalAmountPaid += docData?.transaction?.[i]?.total_paid;
    //       }
    //     } else {
    //       settotalAmountPaid((totalAmountPaid += 0));
    //     }
    //   }
    // }

    // for (let i = 0; i < docData && docData?.transaction.length; i++) {
    //   if (docData?.transaction) {
    //     if (docData?.transaction?.[i]?.amount_due) {
    //       if (docData?.transaction?.[i]?.amount_due === null)
    //         settotalAmount_due((totalAmount_due += 0));
    //       else {
    //         settotalAmount_due(
    //           (totalAmount_due += docData?.transaction?.[i]?.amount_due)
    //         );
    //       }
    //     } else {
    //       settotalAmount_due((totalAmount_due += 0));
    //     }
    //   }
    // }
  }, [docData?.transaction]);

  let address = {};
  if (docData?.account_details?.addresses) {
    for (var i = 0; i < docData?.account_details?.addresses?.length; i++) {
      if (docData?.account_details?.addresses[i]?.billing) {
        address = {
          city: docData.account_details.addresses[i].city,
          state: docData.account_details.addresses[i].state,
          zip_code: docData.account_details.addresses[i].zip_code,
          formattedAddress: `${docData.account_details.addresses[
            i
          ].location?.formattedAddress?.split(",")[0]
            } ${docData.account_details.addresses[i].addressLine2
              ? docData.account_details.addresses[i].addressLine2
              : ""
            } `,
        };
      }
    }
  }

  const TaxStatementPdf =
    docData?.type == "tax_statement" ? (
      <Document id="divToPrint">
        <Page style={styles.docMain}>
          <View>
            <View style={styles.docoHead}>
              <View style={styles.docOrgDetails}>
                <View>
                  <Text style={styles.orgName}>
                    {docData?.organization?.orgName}
                  </Text>
                  <Text style={styles.docOrgDetailsAddress}>
                    {docData?.organization?.contactInfo?.address}
                  </Text>
                  <Text style={styles.docOrgDetailsPhone}>
                    {docData.organization.contactInfo.phone}
                  </Text>
                </View>
                <View styles={styles.image}>
                  <Image src={logoImage} style={styles.logo} />
                </View>
              </View>
            </View>
            <View style={styles.docBody}>
              <View style={styles.docoBodyHeading}>
                <View style={styles.docoBodyHeadingHead}>
                  <Text style={styles.docoBodyHeadingHeadH1}>
                    Statement {docData?.tax_id}
                  </Text>
                  {/* <Text style={styles.docoBodyHeadingHeadP>
                Tax ID {docData?.tax_id}
              </Text> */}
                </View>
                <View style={styles.dateDetails}>
                  <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      To: {docData?.name}{" "}
                    </Text>
                    <Text style={styles.docoBodySubHeadDate}>
                      {moment(docData?.createdAt)
                        .utcOffset("+0100")
                        .format("LL")}
                    </Text>
                  </View>
                  {/* <View style={styles.docoBodySubHead>
                    <Text style={styles.docoBodySubHeadName>
                      Balance: $ {thousands((+totalAmount_due).toFixed(2))}{" "}
                    </Text>
                  </View> */}
                  <View style={styles.docoBodySubHeadAddresses}>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.formattedAddress}
                    </Text>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.city}, {address?.state} {address?.zip_code}
                      {/* {docData?.account_details?.city}
                      {docData?.account_details?.city &&
                        docData?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {docData?.account_details?.state} */}
                    </Text>
                    <Text style={styles.docoBodySubHeadZip}>
                      {docData?.account_details?.zip_code}
                    </Text>
                    <Text style={styles.docoBodySubHeadPhone}>
                      {" "}
                      {docData?.account_details?.admin_contact}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.outStandingMain}>
                <Text style={styles.outStandingText}>
                  Outstanding balance: ${" "}
                  {totalAmount_due?.[0]
                    ? thousands((+totalAmount_due?.[0]).toFixed(2))
                    : "0.00"}{" "}
                  as of{" "}
                  {moment(docData?.date.end).utcOffset("+0100").format("LL")}
                </Text>
              </View>
              <View style={styles.table}>
                <View style={styles.tableHeading}>
                  <Text style={styles.tableHeadingText}>Payments</Text>
                </View>
                <View style={styles.HeaderRow}>
                  <Text style={styles.DateCol}>DATE</Text>
                  <Text style={styles.ChargeDetailCol}>CHARGE DETAILS</Text>
                  <Text style={styles.AmountCol}>AMOUNT</Text>
                  <Text style={styles.AmountPaidCol}>AMOUNT PAID</Text>
                  <Text style={styles.AmountDueCol}>AMOUNT DUE</Text>
                </View>
                {docData?.transaction?.map((item, i) => {
                  return (
                    <View style={styles.BodyRow}>
                      <Text style={styles.DateCol}>
                        {moment(item?.date)
                          .utcOffset("+0100")
                          .format(dateFormet)}
                      </Text>
                      <Text style={styles.ChargeDetailCol}>
                        {item?.details?.Ledger?.name
                          ? item?.details?.Ledger?.name
                          : ""}
                        {item?.details?.SubLedger?.name ? "\n" : ""}
                        {item?.details?.SubLedger?.name
                          ? item?.details?.SubLedger?.name
                          : ""}

                        {item?.visible ? "\n" : ""}
                        {item?.visible ? item?.note : ""}
                      </Text>
                      <Text style={styles.AmountCol}>
                        {/* {getCommaSeperatedValue(item?.total_amount)} */}${" "}
                        {item?.total_amount
                          ? thousands((+item?.total_amount).toFixed(2))
                          : "0.00"}
                      </Text>
                      <Text style={styles.AmountPaidCol}>
                        {/* {getCommaSeperatedValue(item?.total_paid)} */}${" "}
                        {item?.total_paid
                          ? thousands((+item?.total_paid).toFixed(2))
                          : "0.00"}
                      </Text>
                      <Text style={styles.AmountDueCol}>
                        {/* {getCommaSeperatedValue(item?.amount_due)} */}${" "}
                        {item?.amount_due
                          ? thousands((+item?.amount_due).toFixed(2))
                          : "0.00"}
                      </Text>
                    </View>
                  );
                })}
              </View>
              <View style={styles.totalRow}>
                <Text style={styles.DateCol}>Total</Text>
                <Text style={styles.ChargeDetailCol}> </Text>
                <Text style={styles.AmountCol}>
                  {" "}
                  ${" "}
                  {totalAmount?.[0]
                    ? thousands((+totalAmount?.[0]).toFixed(2))
                    : "0.00"}
                </Text>
                <Text style={styles.AmountCol}>
                  {" "}
                  ${" "}
                  {totalAmountPaid?.[0]
                    ? thousands((+totalAmountPaid?.[0]).toFixed(2))
                    : "0.00"}
                </Text>
                <Text style={styles.AmountCol}>
                  {" "}
                  ${" "}
                  {totalAmount_due?.[0]
                    ? thousands((+totalAmount_due?.[0]).toFixed(2))
                    : "0.00"}
                </Text>
              </View>

              <View style={styles.footer}>
                {/* <View style={styles.footerBorder}></View> */}
                <Text className="m-0">
                  Page 1 of 1 | Statement {docData?.tax_id} | Created{" "}
                  {moment(docData?.createdAt)
                    .utcOffset("+0100")
                    .format("MMMM Do, YYYY h:mm A")}
                </Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    ) : (
      ""
    );

  return data ? (
    <div className="NewTaxStatement px-10 d-flex justify-content-center flex-column">
      {isSuccess !== true ? (
        <>
          <h1 className="heading text-center font-weight-bolder heading">
            New Statement
          </h1>
          <div className="mt-10 search d-flex justify-content-between">
            <div
              className="w-50"
              style={{
                marginRight: "6rem",
              }}
            >
              <p className="mb-2">Account Name</p>
              {data ? (
                <SearchDownShift
                  items={data}
                  name={search}
                  setName={setSearch}
                  setId={setId}
                  placeHolder="Search"
                  autoFocus
                />
              ) : null}
            </div>
            <div
              className="w-50 d-flex flex-column"
              style={{
                gap: "1rem",
              }}
            >
              <MyCheckbox
                title="Include closed charges"
                checked={showZero}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setShowZero(checked);
                }}
                disabled={allOpenCharges}
                titleStyles={allOpenCharges ? {
                  opacity: 0.65,
                  pointerEvents: "none",
                } : {}}
              />
              <MyCheckbox
                title="Display credit on account balance"
                checked={showBalance}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setShowBalance(checked);
                }}
              />
            </div>
          </div>
          <div
            className="d-flex justify-content-between align-items-center mt-10"
            style={{
              minHeight: "80px",
            }}
          >
            {/* Left side: Checkboxes in one line */}
            <div className="w-50 d-flex align-items-center" style={{ gap: "2rem" }}>
              <MyCheckbox
                title="All open charges"
                checked={allOpenCharges}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setAllOpenCharges(checked);
                  if (checked) {
                    setShowZero(false);
                  } else {
                    setExcludeActivePayment(false);
                  }

                }}
              />
              <MyCheckbox
                title="Exclude active payment plans"
                checked={excludeActivePayment}
                // disabled={!allOpenCharges}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setExcludeActivePayment(checked);
                  formik.setFieldValue('tax_statement.excludeActivePayment', checked);
                }}
              // titleStyles={!allOpenCharges ? {
              //   opacity: 0.65,
              //   pointerEvents: "none",
              // } : {}}
              />
            </div>
            {/* Right side: Date Range */}
            <div className="w-50">
              {!allOpenCharges && (
                <>
                  <LabelField title={"Date Range"} />
                  <DateRangePicker
                    className="statement-date-range-picker"
                    format={dateFormat}
                    placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    cleanable={true}
                    style={{
                      display: "inline-block",
                      padding: "0",
                      border: "0",
                      width: "100%",
                      color: "black",
                    }}
                    size="lg"
                    value={dateRange}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                  />
                </>
              )}
            </div>

          </div>
          <div
            className="d-flex justify-content-between align-items-center mt-10"
            style={{
              minHeight: "80px",
            }}
          >
            <div className="w-50">
              <LabelField title={"Exclude transactions from selected ledgers"} mandatory={false} />
              <MenuMultiCheckBox
                Items={ledgers}
                formik={formik}
                loading={isLedgerLoading}
                isLedger={true}
                withBorder={true}
                field="all_ledger_sub_data"
              />
            </div>
          </div>
          <div className="mt-10">
            <div>
              <div
                className="w-50 mt-5"
              >
                <MyCheckbox
                  title="Add note"
                  checked={formik.values.addNote}
                  onChange={(e) => {
                    const { checked } = e.target;
                    formik.setFieldValue('addNote', checked);
                  }}
                />
              </div>
              {formik.values?.addNote && (
                <div
                  className="mt-5"
                >
                  <LabelField
                    title={"Note"}
                    mandatory={true}
                  />
                  <TextAreaMessage
                    aria-label="empty textarea"
                    minRows={12}
                    placeholder="Note"
                    value={formik.values?.note}
                    onChange={(e) => {
                      formik.setFieldValue('note', e.target.value);
                    }}
                  />
                </div>
              )}
            </div>

          </div>

          <div className="d-flex justify-content-center mt-10 btn">
            <MyButton
              buttonTextStyle={{ margin: 0, paddingBlock: 4.3 }}
              type={"primary"}
              content={"Create"}
              onClick={create}
            />
          </div>
        </>
      ) : (
        <>
          <div className="d-flex align-items-center">
            <img src={SuccessIcon} className="mr-2" />
            <p className="m-0 font-weight-bolder ">
              Tax Statement successfully created{" "}
            </p>
          </div>
          <div className=" d-flex justify-content-around h-50 align-items-center">
            <div>
              <a className="link" onClick={() => {
                viewDocumentHandler(docData?._id)
              }}>
                <img src={Eye} className="mr-2" />
                View
              </a>
            </div>

            {/* <div>
              <a className="link" onClick={handelDelete}>
                <img src={Download} className="mr-2" />
                Download
              </a>
            </div> */}

            {bol ? (
              "loading..."
            ) : (
              <a className="download" onClick={() => {
                downloadFileHandler(docData)
              }}>
                <IconButton size="large">
                  <img src={Download} alt="download" />
                </IconButton>
                Download
              </a>
            )}

            <div>
              <a className="share" onClick={() => {
                documentHandler(docData)
              }}>
                <img src={Share} className="mr-2" />
                Share
              </a>
            </div>

          </div>
          <div className="d-flex justify-content-center mt-10 closeBtn">
            <MyButton
              buttonTextStyle={{ margin: 0, paddingBlock: 4.3 }}
              type={"primary"}
              content={"Close"}
              onClick={closeModal}
            />
          </div>
        </>
      )}
    </div>
  ) : (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <Loader />
    </div>
  );
};
export default NewTaxStatement;
